import { Box, Typography } from '@mui/material'
import CustomOption2 from '../components/CustomOption2'
import CustomCheckbox from '../components/Inputs/CustomCheckbox'
import TableInputField from '../components/Inputs/TableInputField'

const ScopeOfWorks = () => {
  return (
    <Box sx={{ padding: '20px 0px 40px 0px' }}>
      <Typography className="general-text-light" sx={{ mb: 6 }}>
        <span className="general-text">Task Name - </span>Completion of scope of
        works
      </Typography>
      <Typography className="general-text">Hazardous Elements</Typography>
      <CustomCheckbox
        label="General Hazards"
        name="General_Hazards"
        component={
          <Box>
            <CustomOption2
              label="Returning work area to the state in which you commenced - "
              name="returning_work_area"
              warning={true}
              sliderDescription="Clean up all tools and waste ensuring the site is left in a clean and tidy condition, removing all debris from the area"
            />
            <CustomOption2
              label="Accidental exposure to contaminated wastes. -"
              name="accidental_exposure"
              warning={true}
              sliderDescription="Dispose of all contaminated wastes, using correct procedures. Return unwanted paint to the office for recycling or disposal."
            />
            <CustomOption2
              label="Reconnection of energy sources -"
              name="reconnection_energy_sources"
              warning={true}
              sliderDescription="Return all energy sources when safe to do so"
            />
            <CustomOption2
              label="Traffic hazards -"
              name="traffic hazards"
              warning={true}
              sliderDescription="Remove all signage and safety barriers when works are completed and safe to do so"
            />
          </Box>
        }
        conditional_heading="General Hazards"
      />
      <p>Other Hazardous Elements</p>
      <table>
        <thead>
          <tr>
            <th></th>
            <th>What are the hazards and risks?</th>
            <th>Is it a risk at this site? (Yes/No)</th>
            <th>Inherent Risk Rating (1-4)</th>
            <th>How the hazards and risks be controlled?</th>
            <th>Residual Risk Rating (1-4)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Other 1</td>
            <td>
              <TableInputField name="hazards_and_risks" />
            </td>
            <td>
              <TableInputField name="is_a_risk" />
            </td>
            <td>
              <TableInputField name="inherent_risk_rating" />
            </td>
            <td>
              <TableInputField name="how_hazard_controlled" />
            </td>
            <td>
              <TableInputField name="residual_risk_rating" />
            </td>
          </tr>
        </tbody>
      </table>
      <em style={{ fontSize: '10px', color: 'grey', marginTop: '20px' }}>
        Add other hazardous elements
      </em>
    </Box>
  )
}

export default ScopeOfWorks
